import { savedTokens } from 'src/auth'
import { ErrorApi, ErrorNotLoggedIn, Preloader, Title } from 'src/components'
import OnlineUsersItem from './components/Item'
import { useListActiveUsers } from './queries'
import { savedActiveUserQuery } from './storage'
import InputField from 'src/components/Shared/UIComponents/InputField'

type Props = {
  organization: string
  username: string
}

function OnlineUsers(props: Props) {
  const activeUsers = useListActiveUsers({
    organization: props.organization,
    username: props.username,
  })

  const [query, setQuery] = savedActiveUserQuery.useState('')

  if (activeUsers.isIdle || activeUsers.isLoading) {
    return <Preloader />
  }

  if (activeUsers.isError) {
    return (
      <ErrorApi message={activeUsers.error} onClick={activeUsers.refetch} />
    )
  }

  const filteredUsers = activeUsers.data.filter((user) =>
    user.username.includes(query),
  )

  return (
    <div className="grid grid-cols-2 gap-6 mb-12">
      <Title label="Online Users" />
      <div className="flex flex-row gap-6 col-span-full">
        <InputField
          label="Search users"
          value={query}
          setValue={setQuery}
          type="search"
          hideLabel
          placeholder="Search users"
          className="flex-1"
        />
      </div>

      {filteredUsers.map((user, index) => (
        <OnlineUsersItem
          key={index}
          username={props.username}
          organization={props.organization}
          user={user}
        />
      ))}
    </div>
  )
}

export default function ValidateOnlineUsers() {
  const [tokens] = savedTokens.useState(null)

  if (!tokens) {
    return <ErrorNotLoggedIn />
  }

  return (
    <OnlineUsers
      username={tokens.username}
      organization={tokens.organization}
    />
  )
}
